<template>
  <div id="Tab4">
    <!-- Referral Information -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">IV. Necesidades</span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="eq-ask row">
      <strong class="col-12 mb-4">
        Precise las necesidades que identifica en el aprendizaje del estudiante
        – Describa las necesidades del estudiante solamente en las áreas donde
        confronta retos en su desempeño escolar, en el desarrollo y/o logro de
        las metas y habilidades educativas establecidas en el PEI, considerando
        que están ofreciendo acomodos, modificaciones, adaptaciones
        curriculares, servicios relacionados y las mejores practicas educativas.
      </strong>
    </div>

    <!-- Table -->
    <span class="text-danger">
      {{
        validateNecessities() ? '' : 'Debe seleccionar al menos una necesidad'
      }}
    </span>
    <div class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped mb-5">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-4 pl-5 py-3">
                <span class="ml-1 bold">Necesidad en el Aprendizaje</span>
              </th>
              <th class="col-6 py-3 bold">
                ¿Cómo afectan el desempeño escolar del estudiante?
              </th>
              <th class="col-2 pl-5 py-3">
                <span class="d-flex text-center" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in peiNecessities" :key="index" class="row">
              <td class="col-4 pl-5 py-3">
                <span v-if="row.peiNecessityId == otherOptionId" class="ml-1">
                  {{ row.necessityName }} - {{ row.otherName }}
                </span>
                <span v-else class="ml-1">{{ row.necessityName }}</span>
              </td>
              <td class="col-6 py-3">
                {{ row.description }}
              </td>
              <td class="col-2 dropdown py-3 pr-0">
                <button
                  v-if="!atCompletedFlag"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu my-1">
                  <a class="drop-item" href="#" @click="editRow(row, index)">
                    <i class="fas fa-pencil-alt text-green pr-1" />
                    <span>{{ atCompletedFlag ? 'Leer' : 'Editar' }}</span>
                  </a>
                  <a
                    v-show="!atCompletedFlag"
                    class="drop-item"
                    href="#"
                    @click="confirmDelete(row)"
                  >
                    <i class="fas fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </td>
            </tr>
            <tr class="row">
              <td class="col-12 text-center bg-gray">
                <button
                  id="btnFA"
                  class="btn bg-light-white w-75 pt-1"
                  @click="addNecessity"
                >
                  <i class="fas fa-file-plus pr-4 text-green" />
                  Presione aquí Presione aquí para añadir necesidades
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <EditNecessity
        :is-add-visible="isAddVisible"
        :row="newRow"
        :necessities="selectableNecessities"
        :limit="3000"
        @close="handleEditClose"
        @addNecessity="handleAddNecessity"
      />
    </div>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import EditNecessity from '../EditNecessity';
import store from '@/store/index';
import { commonValues } from '@/utils/constants/at/common';
import loading from '@/mixin/loading.mixin';
import resourcesService from '@/services/resources.js';

export default {
  components: {
    EditNecessity,
  },
  mixins: [loading, alert],
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    selectableNecessities: {
      get: function() {
        const selectedList = this.peiNecessities;
        const editingpeiNecessityId = this.editingpeiNecessityId;
        const otherOptionId = this.otherOptionId;
        return this.necessities.filter((element) => {
          return (
            element.peiNecessityId === otherOptionId ||
            element.peiNecessityId === editingpeiNecessityId ||
            !selectedList.some((selected) => {
              return selected.peiNecessityId === element.peiNecessityId;
            })
          );
        });
      },
    },
    peiAtServiceId() {
      return store.getters.SelectedAt;
    },
  },
  data() {
    return {
      peiId: store.getters.SelectedPei,
      newRow: undefined,
      peiNecessities: [],
      isAddVisible: false,
      necessities: [],
      editingIndex: -1,
      ValidationTriggered: store.getters.getatValidationTriggered,
      editingpeiNecessityId: undefined,
      otherOptionId: commonValues.OTHER_OPTION_NECESSITY_ID,
      resources: [],
    };
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200110',
        'R03200109',
      ]);
    },
    async confirmDelete(row) {
      this.newRow = this.creteNewRow();
      this.isAddVisible = false;
      let response = await alert.methods.ShowConfirm(
        'Atención',
        '¿Está seguro que desea eliminar la necesidad?'
      );
      if (response) {
        this.deleteRow(row);
      }
    },
    editRow(row, index) {
      row.editing = true;
      this.newRow = Object.assign({}, row);
      this.isAddVisible = true;
      this.editingIndex = index;
      this.editingpeiNecessityId = row.peiNecessityId;
    },
    deleteRow(row) {
      this.peiNecessities = this.peiNecessities.filter((x) => x !== row);
    },
    handleAddNecessity(row) {
      if (this.editingIndex > -1) {
        this.peiNecessities[this.editingIndex] = row;
        this.editingIndex = -1;
        this.editingpeiNecessityId = undefined;
      } else {
        this.peiNecessities.push(row);
      }

      this.closeModal();
    },
    addNecessity() {
      this.newRow = this.creteNewRow();
      this.isAddVisible = true;
    },
    closeModal() {
      this.newRow = this.creteNewRow();
      this.isAddVisible = false;
      this.editingIndex = -1;
    },
    creteNewRow() {
      return {
        peiNecessityId: 0,
        description: '',
        otherName: '',
        isNew: true,
        necessityName: '',
        editing: false,
        modified: false,
      };
    },
    save() {
      this.$ApiPost(
        `/api/atservice/${this.peiAtServiceId}/saveatnecessities/${this.peiId}`,
        this.peiNecessities
      )
        .then(
          function(res) {
            if (this.peiAtServiceId != res.data.peiAtServiceId) {
              this.peiAtServiceId = res.data.peiAtServiceId;
              store.dispatch('setSelectedAt', this.peiAtServiceId);
            }
            this.peiNecessities = res.data.data;
            this.ShowToast(
              this.resources['R03200110'],
              this.resources['R03200109'],
              'success'
            );
          }.bind(this)
        )
        .catch((err) => {
          this.response = err;
        });
    },
    getPeiAtServiceId(peiAtServiceId) {
      peiAtServiceId = store.getters.SelectedAt;
      this.$ApiGet(`/api/atservice/${peiAtServiceId}/getnecessities`)
        .then(
          function(res) {
            this.peiNecessities = res.data || [];
          }.bind(this)
        )
        .catch((err) => {
          this.response = err;
        });
    },
    handleEditClose() {
      this.isAddVisible = false;
      this.editingpeiNecessityId = undefined;
    },
    validateNecessities() {
      if (this.ValidationTriggered.validation) {
        if (
          this.peiNecessities == undefined ||
          this.peiNecessities.length == 0
        ) {
          return false;
        }
      }
      return true;
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab4')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
  },
  beforeMount() {
    this.newRow = this.creteNewRow();
  },
  mounted() {
    this.$ApiGet('/api/atservice/atnecessitieslist')
      .then(
        function(res) {
          this.necessities = res.data || [];
        }.bind(this)
      )
      .catch((err) => {
        this.response = err;
      });

    if (this.peiAtServiceId !== 0) {
      this.getPeiAtServiceId(this.peiAtServiceId);
    }

    this.validateReadMode();
    this.loadResources();
  },
};
</script>

<style scoped>
@import '../../../assets/css/screen-general-ref.css';
@import '../../../assets/css/info-evaluations.css';
</style>
